import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
// @ts-ignore
// eslint-disable-next-line import/no-extraneous-dependencies,ordered-imports/ordered-imports
import { Howl } from 'howler';

import { Cell, Container, Grid, Icon } from '@zeiss/ods-components-react';

import { NavLeftIcon, NavRightIcon } from '../../icons';
import { useSlider } from '../../hooks';

import {
  StyledFooter,
  StyledFooterContent,
  StyledFooterLeftNavButton,
  StyledFooterMenu,
  StyledFooterNavigation,
  StyledFooterRightNavButton,
  StyledSliderIndicator,
} from './styled';

const Footer = () => {
  const { swiper, activeSlide } = useSlider();
  const navigate = useNavigate();
  const location = useLocation();
  let nextLabel;
  let prevLabel;

  if (swiper && swiper.slides.length > 0) {
    const nextSlide = swiper.slides[activeSlide + 1];
    const prevSlide = swiper.slides[activeSlide - 1];
    nextLabel = nextSlide ? nextSlide.id : '';
    prevLabel = prevSlide ? prevSlide.id : '';
  }

  const goToOverviewAudio = new Howl({
    src: ['./audios/interaction-sounds/nav-to-overview-2.mp3'],
    volume: 0.01,
  });

  const nextAudio = new Howl({
    src: ['./audios/interaction-sounds/nav-tap-next.mp3'],
    volume: 0.01,
  });

  const prevAudio = new Howl({
    src: ['./audios/interaction-sounds/nav-tap-prev.mp3'],
    volume: 0.01,
  });

  return location.pathname !== '/overview' ? (
    <StyledFooter>
      <Grid>
        <Container.FullBleed>
          <Cell.Basic colStarts={[1, 1, 2]} colSpan={10}>
            <StyledFooterContent>
              {swiper && (
                <StyledSliderIndicator
                  activeSlideIndex={activeSlide}
                  items={swiper?.slides.length}
                >
                  <span>
                    <span />
                  </span>
                </StyledSliderIndicator>
              )}
              <StyledFooterNavigation>
                <StyledFooterLeftNavButton>
                  {prevLabel && (
                    <button
                      type="button"
                      onClick={() => {
                        prevAudio.play();
                        swiper?.slidePrev();
                      }}
                    >
                      <NavLeftIcon />
                      {prevLabel}
                    </button>
                  )}
                </StyledFooterLeftNavButton>
                <StyledFooterMenu>
                  <button
                    type="button"
                    onClick={() => {
                      goToOverviewAudio.play();
                      navigate('/overview');
                    }}
                  >
                    <Icon icon="BurgerMenu" size={20} />
                  </button>
                </StyledFooterMenu>
                <StyledFooterRightNavButton>
                  {nextLabel && (
                    <button
                      type="button"
                      onClick={() => {
                        nextAudio.play();
                        swiper?.slideNext();
                      }}
                    >
                      {nextLabel}
                      <NavRightIcon />
                    </button>
                  )}
                </StyledFooterRightNavButton>
              </StyledFooterNavigation>
            </StyledFooterContent>
          </Cell.Basic>
        </Container.FullBleed>
      </Grid>
    </StyledFooter>
  ) : null;
};

export default Footer;
